import { useAppSelector } from '@hooks';
import { getSpecialPage, getSystemPages } from '@store/app/app.slice';
import { getTextFromHtml, replaceTemplateSyntax } from '@utils/text.utils';
import { useSelector } from 'react-redux';

type SendSmsParams = {
  user?: string;
  to: string;
  message: string;
};

type CreateSmsMessageParams = {
  token: string;
  textMessage?: string;
};

export const useSendSms = () => {
  const smsServiceApiPassword = useSelector(getSystemPages).smsServiceApiPassword as string;
  const consentPage = useAppSelector(getSpecialPage('buyersCertificateConsentPage')) as string;

  const sendSms = async ({ user = 'berema', to, message }: SendSmsParams) => {
    const passwd = smsServiceApiPassword;
    const baseUrl = 'https://sveve.no/SMS/SendMessage';
    const encodedMessage = encodeURIComponent(message);
    const fullUrl = `${baseUrl}?user=${user}&passwd=${passwd}&to=${to}&msg=${encodedMessage}&f=json`;

    try {
      const response = await fetch(fullUrl);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error:', error);
      return error;
    }
  };

  const createSmsMessage = ({ token, textMessage }: CreateSmsMessageParams) => {
    const consentUrl = `${window.location.origin}${consentPage}?token=${token}`;
    const templates = {
      ConsentUrl: consentUrl,
    };
    //todo: remove console.log after testing
    console.log(consentUrl);
    return getTextFromHtml(replaceTemplateSyntax(textMessage, templates) || '');
  };

  return { sendSms, createSmsMessage };
};
